export default function DesMoinesProcessingTimeSection() {
  return (
    <section id="processing" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Processing Options</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            How Fast Can You Get a Passport in Des Moines?
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Three options for Des Moines and central Iowa travelers. Choose based on your travel timeline and urgency.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg p-7 border border-gray-200 flex flex-col">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50">
                <i className="ri-flashlight-line text-red-500 text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Emergency</h3>
                <p className="text-red-500 text-xs font-semibold">24–72 Hours</p>
              </div>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-6 flex-1">
              For Des Moines travelers with life-or-death emergencies or travel within 72 hours. Our fastest courier submission with reserved agency access.
            </p>
            <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center justify-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-bold text-sm px-5 py-3 rounded-md transition-all whitespace-nowrap">
              Get Emergency Service <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="bg-white rounded-lg p-7 border-2 border-[#F6C344] flex flex-col relative">
            <span className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#F6C344] text-[#1A365D] text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
              Most Popular
            </span>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#F6C344]/15">
                <i className="ri-rocket-line text-[#1A365D] text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Expedited</h3>
                <p className="text-[#F6C344] text-xs font-semibold">3–9 Business Days</p>
              </div>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-6 flex-1">
              The best balance of speed and value for Des Moines travelers. Perfect for trips 2–3 weeks out. Courier submission with full tracking.
            </p>
            <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center justify-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-3 rounded-md transition-all whitespace-nowrap">
              Start Expedited <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="bg-white rounded-lg p-7 border border-gray-200 flex flex-col">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100">
                <i className="ri-time-line text-gray-500 text-lg"></i>
              </div>
              <div>
                <h3 className="font-bold text-[#1A365D] text-base">Standard</h3>
                <p className="text-gray-500 text-xs font-semibold">6–13 Weeks</p>
              </div>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-6 flex-1">
              Through the post office or acceptance clerk in Des Moines. Budget-friendly but slow. Best if your trip is at least 4 months away.
            </p>
            <a href="#acceptance-facilities" className="inline-flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold text-sm px-5 py-3 rounded-md transition-all whitespace-nowrap">
              Find Locations <i className="ri-map-pin-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}